import React from 'react';
import RepProfileCalls from '$pages/$rep-profile/RepProfileCalls';

export default class RepCalls extends React.Component {
  render() {
    const {RepProfilePageActions, RepProfilePageStore, UserStore} = this.props;
    const {
      teamConversationTrend,
      teamCallDurationTrend,
      didTeamConversationTrendFail,
      didTeamCallDurationTrendFail,
      isTeamConversationTrendFetching,
      isTeamCallDurationFetching,
      openSummaries,
    } = RepProfilePageStore;
    const repBeingViewed = UserStore.users.get(this.props.repId);
    return (
      <div className="tab-content">
        {didTeamCallDurationTrendFail || didTeamConversationTrendFail ? (
          <p>There was a problem fetching the coaching activity.</p>
        ) : (
          <RepProfileCalls
            teamConversationTrend={teamConversationTrend}
            teamCallDurationTrend={teamCallDurationTrend}
            rep={repBeingViewed}
            openCallDetails={RepProfilePageActions.openCallDetails}
            openSummaries={openSummaries}
            callDetails={RepProfilePageStore.callDetails}
            callDetailsLoading={RepProfilePageStore.callDetailsLoading}
            callDetailsFailed={RepProfilePageStore.callDetailsFailed}
            getCallDetails={RepProfilePageActions.getCallDetails}
            getInfoAboutFiles={this.props.getInfoAboutFiles}
            isLoading={isTeamCallDurationFetching || isTeamConversationTrendFetching}
            getCoachingActivity={RepProfilePageActions.getCoachingActivity}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            headerStartDate={this.props.headerStartDate}
            headerEndDate={this.props.headerEndDate}
            location={this.props.location}
          />
        )}
      </div>
    );
  }
}
